import React, { useState } from 'react';
import { Button, Collapse, Form, Message, Space, Tabs } from '@bedrock/components';
import classNames from 'classnames/bind';
import styles from './index.less';
import CollapseTablePanel from '#components/CollapseTablePanel';
import FormItemDescriptions from "#components/DescriptionsFormItem";
import { Copy2, Delete, Plus, SignIn } from '@bedrock/icons-react';
// import { useImportFileModal } from "#features/importFileModal";
import SupplierVisible from '@mpc/common/src/features/SupplierVisible';
import { get } from 'lodash';
import { ProCard } from '@bedrock/eed-react';
import { useDemandOptions } from '#features/useDemandOptions';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

interface Props {
  tabsModel?: boolean;
  addable?: boolean;
  deletable?: boolean;
  name?: string | string[];
  view?: boolean;
  formData?: any;
  changeFormData?: (name, value) => void;
  style?: React.CSSProperties;
  className?: string;
  l3_category_id?: any;
  detail?: any;
  proCardProps?: any;
  // 底部插槽
  bottomSlot?: React.ReactNode;
}

const DEFAULT_ACTIVE_KEYS = Array.from({ length: 20 }, (_, i) => i);
const ALL_ACTIVE_KEYS = Array.from({ length: 1000 }, (_, i) => i);

const RequirementContent = (props: Props) => {
  const {
    view,
    tabsModel,
    addable = true,
    deletable = true,
    name=['demand_source_detail_vo', 'demand_source_content_vo'],
    formData,
    changeFormData,
    style,
    className,
    l3_category_id,
    detail,
    proCardProps,
    bottomSlot,
  } = props;
  const [activeKeys, setActiveKeys] = useState<number[]>(tabsModel ? ALL_ACTIVE_KEYS : DEFAULT_ACTIVE_KEYS);
  const [activeTabKey, setActiveTabKey] = useState('0');
  // const { openImportFileModal, closeImportFileModal } = useImportFileModal({});
  const { optionsMap } = useDemandOptions({

    keys: ['main_platform', 'public_order_new'],
    params: {
      l3_category_id,
    }
  });
  
  return (
    <div style={style} className={className}>
      <ProCard
        title={<SupplierVisible>需求内容</SupplierVisible> as any}
        level={2}
        noPadding
        {...proCardProps}
      >
    <Form.List
      name={name}
      initialValue={[{}]}
    >

      {(fields, { add, remove }) => {
        return <>
            {fields?.length > 1 && tabsModel && <Tabs activeKey={activeTabKey} type="card" onChange={(v) => { setActiveTabKey(v) }} className='m-b-8'>
              {
                fields?.map((field, index) => {
                  return <Tabs.TabPane tab={`需求内容${index + 1}`} key={index + ''}></Tabs.TabPane>
                })
              }
            </Tabs>}
            {
              fields?.map((field, index) => {
                if (tabsModel && index !== Number(activeTabKey)) {
                  return null
                }
                const { key, ...fieldRest } = field;
                const fieldConfig = (fieldType: string) => {
                  return {
                    ...fieldRest,
                    formItemKey: [field.name, fieldType],
                    name: [field.name, fieldType],
                    fieldKey: [field.key, fieldType],
                    view,
                  }
                }

                return (
                  <FormItemDescriptions
                    lightBorder
                    className={cx('collapse-content-table')}
                    column={2}
                    items={[
                      {
                        ...fieldConfig('main_platform'),
                        label: '合作主平台',
                        required: true,
                        componentClass: "select",
                        span: 1,
                        elementProps: {
                          options: optionsMap?.main_platform?.options,
                          multiple: true,
                        }
                      },
                      {
                        ...fieldConfig('public_order'),
                        label: '主平台官单/私单',
                        required: false,
                        componentClass: "select",
                        span: 1,
                        elementProps: {
                          options: optionsMap?.public_order_new?.options?.filter(v => v.level === 0),
                          multiple: true,
                        }
                      },
                      {
                        ...fieldConfig('$release_time'),
                        label: '发布时间',
                        required: false,
                        componentClass: "datePicker",
                        span: 1,
                        elementProps: {
                          range: true,
                          showComponent: () => {
                            const listData = get(detail, name);
                            const begin_at = listData?.[index]?.begin_at;
                            const end_at = listData?.[index]?.end_at;
                            return (begin_at && end_at) ? `${dayjs(begin_at).format('YYYY-MM-DD')} 至 ${dayjs(end_at).format('YYYY-MM-DD')}` : '--'
                          }
                        },
                      },
                      {
                        ...fieldConfig('content_desc'),
                        label: '需求内容',
                        required: true,
                        componentClass: "textarea",
                        span: 2,
                        elementProps: {
                          maxLength: 1000,
                        }
                      },
                    ]}
                  />
                )

                return (
                  <Collapse
                    activeKey={activeKeys.includes(index) ? [1] : undefined}
                    key={index}
                    onChange={(key) => {
                      setActiveKeys(activeKeys.includes(index) ? activeKeys.filter((i) => i !== index) : [...activeKeys, index])
                    }}
                  >
                    <CollapseTablePanel
                      className={tabsModel ? 'mb-[0]' : ''}
                      style={{ width: '100%' }}
                      header={<div className={cx('inner-header')}>
                        <div>需求内容{index + 1}</div>
                        <div>
                          <Space size={0}>
                            {addable && !view &&
                              <Button type="text-subtle" size="xSmall" icon={<Copy2 />}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  const listData = get(formData, name);
                                  const copyData = JSON.parse(JSON.stringify(listData[index]))
                                  add(copyData, index + 1)
                                }}
                              >
                                复制
                              </Button>
                            }

                            {deletable && !view &&
                              <Button type="text-subtle" size="xSmall" icon={<Delete />}
                                disabled={fields?.length === 1}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  remove(field.name);
                                }}
                                danger
                              >
                                删除
                              </Button>
                            }
                          </Space>
                        </div>
                      </div>}
                      key={1}
                    >
                      <FormItemDescriptions
                        lightBorder
                        className={cx('collapse-content-table')}
                        column={2}
                        items={[
                          {
                            ...fieldConfig('main_platform'),
                            label: '合作主平台',
                            required: true,
                            componentClass: "select",
                            span: 1,
                            elementProps: {
                              options: optionsMap?.main_platform?.options,
                            }
                          },
                          {
                            ...fieldConfig('public_order'),
                            label: '主平台官单/私单',
                            required: false,
                            componentClass: "select",
                            span: 1,
                            elementProps: {
                              options: optionsMap?.public_order_new?.options?.filter(v => v.level === 0),
                            }
                          },
                          {
                            ...fieldConfig('$release_time'),
                            label: '发布时间',
                            required: false,
                            componentClass: "datePicker",
                            span: 1,
                            elementProps: {
                              range: true,
                              showComponent: () => {
                                const listData = get(detail, name);
                                const begin_at = listData?.[index]?.begin_at;
                                const end_at = listData?.[index]?.end_at;
                                return (begin_at && end_at) ? `${dayjs(begin_at).format('YYYY-MM-DD')} 至 ${dayjs(end_at).format('YYYY-MM-DD')}` : '--'
                              }
                            },
                          },
                          {
                            ...fieldConfig('content_desc'),
                            label: '需求内容',
                            required: true,
                            componentClass: "textarea",
                            span: 2,
                            elementProps: {
                              maxLength: 1000,
                            }
                          },
                        ]}
                      />
                    </CollapseTablePanel>
                  </Collapse>
                )
              })
            }
            {/* {!view && addable && <>
              <Button type="checked" icon={<Plus />}
                onClick={() => {
                  add({});
                }}
                style={{ width: '100%' }}
                size='large'
              >
                添加需求内容
              </Button>
            </>} */}
        </>
      }}
    </Form.List>
        {bottomSlot}
      </ProCard>
    </div>
  )
}

export default RequirementContent;
